import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/login/login-qllLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-219225ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-header-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "企联联")
], -1))
const _hoisted_3 = { class: "el-header-right" }
const _hoisted_4 = { class: "main" }

import Menu from "@/components/Layout/MenuView.vue";
import HeaderRight from "@/components/Layout/HeaderRight.vue";
import UserTools from "../services/session/UserTools";
import { reactive, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { NavigationTabName } from "@/config/ui/NavigationTabName";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import CheckType from "@/utils/CheckType";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
import Notice from "@/components/Notice.vue";
import { addQllRoute } from "@/router";
import { CheckIslink } from "@/router/route";
import MenuListUtil from "@/utils/MenuList";
import finance from "@/api/finance";
import { ServerConfig } from "@/config/server-config";
interface NavigationTabs {
  title: string;
  index: string | number;
  subs: any;
  perMiss: number;
  icon: string;
  iconSelect: string;
}

interface RouteMenu {
  path: string;
  title: string;
  component: string;
  isLink: boolean;
}
// interface UserMessage {
//   name: string;
//   logo: string;
// }

// VUEX

export default /*#__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

console.log("2023.7.18 17:41");

console.log("2023.7.18 17:41");

const $store = useStore();
// 路由
const routers = useRouter();
// 路由列表
const routeMenu = reactive<RouteMenu[]>([]);
// 角色列表
const userRoleList = reactive<string[]>([]);
// 左侧menu、列表
const getNavigationTabs = reactive<NavigationTabs[]>([]);
// 切换角色高亮
const userRoleIndex = ref<number>(
  Number(localStorage.getItem("userRoleIndex"))
);
// 角色信息
let userMessage = ref({ name: "", logo: "" });

const getUserList = async (): void => {
  const userList = UserTools.userRoles.roles;
  console.log(userList, 444);
  $store.commit("currentRole/updateCurrentRole", userList[userRoleIndex.value]);
  userRoleList.splice(0, userRoleList.length);
  userList.forEach((r) => {
    if (r.getDisplayName() && r.enterpriseInfo?.entityId) {
      userRoleList.push(
        r.enterpriseInfo?.entityName + ":" + r.getDisplayName()
      );
    }
  });
  console.log(userRoleList);
  userRoleList.push("退出登陆");
  userMessage.value = {
    name: userList[userRoleIndex.value].enterpriseInfo.entityName,
    logo: userList[userRoleIndex.value].enterpriseInfo.logoImgUrl
      ? CheckType.isImg(userList[userRoleIndex.value].enterpriseInfo.logoImgUrl)
      : require("../assets/images/HeaderRight/enterpriseLogo.png"),
  };
  getNavigationTabs.splice(0, getNavigationTabs.length);
  routeMenu.splice(0, routeMenu.length);
  let menuList = MenuListUtil.getMenuList(
    userList[userRoleIndex.value].enterpriseInfo.enterpriseType,
    userList[userRoleIndex.value].getRoleType()
  );
  try {
    await finance.getIncome();
  } catch (e) {
    menuList = menuList.filter((link) => link[1] != "/layout/finance");
  }
  let currentRole =
    UserTools.userRoles.roles[$store.state.currentRole.roleIndex];
  menuList.forEach((value) => {
    console.log(value, 11233456);
    const text = value[1].split("/")[2];
    if (
      NavigationTabName.getDisplayName(value[0]) ||
      currentRole.enterpriseInfo.enterpriseType === 29
    ) {
      const component =
        text.split("")[0].toUpperCase() + text.slice(1, text.length);
      getNavigationTabs.push({
        title: NavigationTabName.getDisplayName(value[0]) || "客服回访",
        index: value[1],
        subs:
          value[0] == 3
            ? [
                {
                  title: "律师信息",
                  index: "/layout/entiyInfo",
                  subs: [
                    {
                      title: "个人简介",
                    },
                    {
                      title: "个人荣耀",
                    },
                    {
                      title: "发布案例",
                    },
                  ],
                },
                {
                  title: "律所信息",
                  index: "/layout/lawfirm",
                  subs: [
                    {
                      title: "律师简介",
                    },
                    {
                      title: "公司荣耀",
                    },
                    {
                      title: "团队维护",
                    },
                  ],
                },
              ]
            : null,
        perMiss: value[0],
        icon: require("@/assets/images/MenuIcon/" + component + ".png"),
        iconSelect: require("@/assets/images/MenuIcon/" + component + "1.png"),
      });
    }
  });
  sessionStorage.setItem(
    "linkList",
    JSON.stringify(userList[userRoleIndex.value].getNavigationTabs())
  );
  sessionStorage.setItem("length", JSON.stringify(getNavigationTabs.length));
  addQllRoute(CheckIslink(userList[userRoleIndex.value].getNavigationTabs()));
  // await routers.push({
  //   path:
  //     getNavigationTabs.length === 4 || getNavigationTabs.length === 3
  //       ? "/layout/home"
  //       : "/layout/order",
  // });
};
// 切换角色身份方法
const updateUserRole = (val: number): void => {
  if (val == userRoleList.length - 1) {
    localStorage.setItem("userRoleIndex", "0");
    // 登出
    DefaultWebServiceFactory.getInstance()
      .getWebSystemService()
      .logout()
      .then((t) => {
        if (t.getResult()) {
          // window.location.reload()
          routers.push("/");
          window.location.reload();
        }
      });
  } else {
    localStorage.setItem("userRoleIndex", val);
    userRoleIndex.value = val;
    $store.commit("currentRole/updateRoleIndex", val);
    getUserList();
  }
};
onMounted(() => {
  // 开启浏览器系统通知
  if (localStorage.getItem("version") != ServerConfig.version) {
    window.location.reload(true);
    localStorage.setItem("version", ServerConfig.version);
  }
  if (Notification.permission === "default") {
    ElMessage.success("为了更好的通知您接受服务,左上角通知权限请点击允许!");
    Notification.requestPermission(function () {
      Notification.permission === "granted"
        ? ElMessage.success("律师需求推送已开启!")
        : ElMessage.error(
            "开启失败,您将无法实时获取到实时需求通知,如需推送请浏览器手动给予通知权限!"
          );
      $store.commit(
        "message/updateState",
        Notification.permission === "granted"
      );
    });
  }
  getUserList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(HeaderRight, {
                userRoleList: userRoleList,
                userRoleIndex: userRoleIndex.value,
                userMessage: _unref(userMessage),
                onUpdateUserRole: updateUserRole
              }, null, 8, ["userRoleList", "userRoleIndex", "userMessage"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, null, {
              default: _withCtx(() => [
                _createVNode(Menu, { menuList: getNavigationTabs }, null, 8, ["menuList"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_router_view),
                  _createVNode(Notice)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})